module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/* Html5Player Banner */
(function (fox, $) {
	"use strict";

	fox.registerWidget('Html5Player_MC_Banner', {
		configure: function (options) {
			this.registerOptions('', {
				'!template': 'Html5Player_MC_Banners',
				useSimpleBanner: false,
				onPausePlayerImage: require('../images/player/banners/guest_large.png'),
				onPausePlayerSmallImage: require('../images/player/banners/guest_small.png')
			});

			this.pm = fox.wom.selectFirst('~.PermissionManager');

			this.callParent('configure', arguments);
		},

		init: function() {
			this.prepareBanners();

			this.callParent('init', arguments);
		},

		prepareBanners: function() {
			var isFreeRegEnabled = (fox.getEnv('siteProps.freeJoin') === '1');
			var guestAccess = this.pm.hasAccess('guest');
			var isFreeMember = (guestAccess && !fox.isEmpty(this.pm.getMemberInfo()));

			this.largeImg = this.getOption('onPausePlayerImage');
			this.smallImg = this.getOption('onPausePlayerSmallImage');

			if (this.getOption('useSimpleBanner') === true) {
				return;	
			}

			if (isFreeMember) {
				this.largeImg = require('../images/player/banners/freeMember_large.png');
				this.smallImg = require('../images/player/banners/freeMember_small.png');

				return;
			}

			if (guestAccess && isFreeRegEnabled) {
				this.largeImg = require('../images/player/banners/guest_freeReg_large.png');
				this.smallImg = require('../images/player/banners/guest_freeReg_small.png');

				return;
			}

		},

		setBanner: function() {
			if (this.pm.hasAccess('member')) {
				return;
			}

			this.setOption('manualRender', false);

			this.setTemplateOptions({
				largeImg: this.largeImg,
				smallImg: this.smallImg,
				url: fox.getEnv('siteProps.ubs.joinUrl') || '/join',
				component: this.getOption('component'),
				cName: this.getOption('cName')
			});

			this.render();

		}

	}, 'Html5Player_Banner');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/playerBanners.js
// module id = 892
// module chunks = 4